(function() { window.GUID_e0e79927_7db1_4266_99ac_54c0981818ea = { getGuid: function() { return "e0e79927-7db1-4266-99ac-54c0981818ea"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let SwipeableItemContent;
        (function (SwipeableItemContent) {
            SwipeableItemContent[SwipeableItemContent["Award"] = 0] = "Award";
            SwipeableItemContent[SwipeableItemContent["EventListEventPicture"] = 1] = "EventListEventPicture";
            SwipeableItemContent[SwipeableItemContent["EventWallEventPicture"] = 2] = "EventWallEventPicture";
            SwipeableItemContent[SwipeableItemContent["FollowedPlayerCard"] = 3] = "FollowedPlayerCard";
            SwipeableItemContent[SwipeableItemContent["PlayerCard"] = 4] = "PlayerCard";
            SwipeableItemContent[SwipeableItemContent["ProfilePicture"] = 5] = "ProfilePicture";
            SwipeableItemContent[SwipeableItemContent["TeamCard"] = 6] = "TeamCard";
            SwipeableItemContent[SwipeableItemContent["TeamHeader"] = 7] = "TeamHeader";
            SwipeableItemContent[SwipeableItemContent["TeamMember"] = 8] = "TeamMember";
            SwipeableItemContent[SwipeableItemContent["MatchDetailsOpponent"] = 9] = "MatchDetailsOpponent";
        })(SwipeableItemContent = Enumeration.SwipeableItemContent || (Enumeration.SwipeableItemContent = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=SwipeableItemContent.pre.js.map
